<template>
  <header id="box-header" class="row" data-test="box-header">
    <div class="col-2">
      <button
        :aria-label="$t(`btnRestart`)"
        v-if="navigation"
        @click="restartFlow()"
        class="btn btn-secondary-icon"
        data-test="restart-flow-button"
      >
        <span
          aria-hidden="true"
          class="cm-icon cm-icon-previous"
          data-cm-icon="https://www.cm.com/en-gb/app/aurora/svg/previous.svg"
          ><svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            cm-icon-url="https://www.cm.com/en-gb/app/aurora/svg/previous.svg"
          >
            <path
              fill="#3C4859"
              fill-rule="evenodd"
              d="M14.00025,18.00025 C13.74425,18.00025 13.48825,17.90225 13.29325,17.70725 L8.29325,12.70725 C7.90225,12.31625 7.90225,11.68425 8.29325,11.29325 L13.29325,6.29325 C13.68425,5.90225 14.31625,5.90225 14.70725,6.29325 C15.09825,6.68425 15.09825,7.31625 14.70725,7.70725 L10.41425,12.00025 L14.70725,16.29325 C15.09825,16.68425 15.09825,17.31625 14.70725,17.70725 C14.51225,17.90225 14.25625,18.00025 14.00025,18.00025"
            ></path></svg
        ></span>
      </button>
    </div>
    <div class="col-8">
      <h1>{{ title }}</h1>
    </div>
    <div class="col-2 text-right">
      <language-switch></language-switch>
    </div>
  </header>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const paymentNS = createNamespacedHelpers("payment");
import languageSwitch from "@/components/language-switch.vue";

export default {
  name: "pageHeader",
  components: {
    languageSwitch,
  },
  props: {
    navigation: {
      default: false,
      type: Boolean,
    },
    url: {
      default: "",
      type: String,
    },
    title: {
      default: "",
      type: String,
    },
  },
  computed: {
    ...paymentNS.mapGetters(["language", "page"]),
  },
  methods: {
    ...paymentNS.mapActions(["restart"]),
    restartFlow() {
      this.restart();
    },
  },
};
</script>
